import requestAPI from '@/logic/requestBeApi';

const reportsAPI = {
  getVirtualAssessmentReport(virtualAssessmentReportPath: string): Promise<Response> {
    return requestAPI({
      method: 'GET',
      url: `${virtualAssessmentReportPath}`,
    });
  },

  getCandidate(candidateId: string): Promise<Response> {
    return requestAPI({
      method: 'GET',
      url: `/api/v1/candidates/${candidateId}`,
    });
  },

  uploadVirtualReport(VAReport: Record<string, unknown>, status: string): Promise<Response> {
    const payload = {
      comments: VAReport.comments,
      fits: VAReport.fits,
      status: status,
      properties: VAReport.properties,
    };

    return requestAPI({
      method: 'PATCH',
      contentType: 'application/merge-patch+json',
      url: `/api/v1/virtual-assessment-reports/${VAReport.id}`,
      payload,
    });
  },
};

export default reportsAPI;
